module.exports = __webpack_public_path__ + "img/bs4.dfa83765.png";